<template>
  <div>
    <Breadcrumbs primary="Финансы" secondary="Детализация"/>

    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="box-card no-top-body-padding no-border">
          <FinancialOperationsReport get-report-url="/finance/getDetailReport" />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import FinancialOperationsReport from "@shared/components/finance/detailing-report/detailing-report.component"

export default {
  name: "FinancialOperations",
  title: "Детализация",
  components: {FinancialOperationsReport}
}
</script>